<template>
  <v-form ref="form" style="width: 100%; padding-top: 0px;">
    <v-card-text>
      <v-text-field :rules="[rules.required]" required v-model="formObject.newSynonymName" label="Alias name" />
      <template v-if="isSystemAdmin">
        <v-subheader class="pl-0">System Administrator Settings</v-subheader>
        <v-checkbox color="info" class="mt-0" v-model="formObject.isPrimary" label="Make primary alias" persistent-hint hint="The primary alias is the name used in reports" />
      </template>
    </v-card-text>
    <v-alert key="alert" outline class="my-0" type="warning" :value="formObject.isPrimary">
      <div class="primary--text">
        The primary alias name shows up in reports, which may cause confusion if the primary alias does not match the
        location name.
      </div>
    </v-alert>
  </v-form>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const dataSources = createNamespacedHelpers('datasource')
  const app = createNamespacedHelpers('app')
  const synonyms = createNamespacedHelpers('synonyms')
  const authenticate = createNamespacedHelpers('authenticate')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    props: {
      givenStation: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        formObject: {
          newSynonymName: null,
          isPrimary: false,
        },
        rules: {
          required: value => !!value || 'Required',
        },
      }
    },
    computed: {
      ...authenticate.mapGetters(['isSystemAdmin']),
      _givenStation() {
        return {
          Id: this.givenStation.Id,
          Name: this.givenStation.LocationIdentifier,
        }
      },
      givenStationId() {
        return this._givenStation && this._givenStation.Id
      },
    },
    methods: {
      ...dataSources.mapActions(['fetchDataSources']),
      ...app.mapActions(['setSnackbar']),
      ...synonyms.mapActions(['addSynonym']),
      close() {
        this.$emit('close')
      },
      async submit() {
        if (!this.$refs.form.validate()) return

        try {
          await this.addSynonym({
            synonymName: this.formObject.newSynonymName,
            isPrimary: this.formObject.isPrimary,
            sourceId: this.givenStationId,
            sourceType: SOURCE_TYPES.continuousAquarius,
          })

          await this.fetchDataSources({
            sourceTypes: [SOURCE_TYPES.continuousAquarius],
          })

          this.setSnackbar({
            text: 'Synonym added successfully',
            color: 'success',
            icon: 'done',
            timeout: -1,
          })

          this.close()
        } catch (error) {
          console.error(error)
          let errorText = error.Message ? error.Message : error
          this.setSnackbar({
            text: errorText,
            color: 'error',
            icon: 'error',
          })
        }
      },
    },
  }
</script>